var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-img" }, [
    this.imgErrorShowText === true
      ? _c("p", { style: { color: "#B01000" } }, [
          _vm._v(_vm._s(_vm.imgErrorText) + "  " + _vm._s(_vm.getThumbnail()))
        ])
      : _vm._e(),
    this.imgError === false
      ? _c("img", {
          staticClass: "image",
          attrs: { src: _vm.baseUrl + _vm.url }
        })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-349b18fa", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-349b18fa","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/SerieThumbnail.vue
// module id = 888
// module chunks = 0